<template>
	<v-container fluid class="pt-0">
		<v-row>
			<v-col cols="12" xl="12" lg="12" md="12">
				<v-tabs>
					<v-tab>{{ $t('tabs.basicInfo') }}</v-tab>
					<v-tab v-if="$route.params.id != 0 && !inEditMode">{{ $t('tabs.candidates') }}</v-tab>
					<v-tab
						v-if="
							$route.params.id != 0 &&
							plannedCourse.planned_course_status_id != 4 &&
							plannedCourse.planned_course_status_id != 5 &&
							!inEditMode
						"
						>{{ $t('tabs.appointments') }}</v-tab
					>
					<v-tab
						v-if="
							$route.params.id != 0 &&
							plannedCourse.planned_course_status_id != 4 &&
							plannedCourse.planned_course_status_id != 5 &&
							!inEditMode
						"
						>{{ $t('tabs.schedule') }}</v-tab
					>
					<v-tab v-if="$route.params.id != 0 && !inEditMode">{{ $t('tabs.teachers') }}</v-tab>
					<v-tab v-if="$route.params.id != 0 && !inEditMode">{{ $t('tabs.costs') }}</v-tab>
					<v-tab
						v-if="
							$route.params.id != 0 &&
							!inEditMode &&
							(plannedCourse.planned_course_status_id == 3 || plannedCourse.planned_course_status_id == 5)
						"
						>{{ $t('tabs.surveys') }}</v-tab
					>
					<v-tab-item>
						<v-card flat outlined>
							<v-card-text>
								<v-row>
									<v-flex xs12 md4 lg4>
										<v-card-title class="pa-2 pl-4">{{
											$t('titles.courseSelection')
										}}</v-card-title>
									</v-flex>
									<v-flex class="d-flex justify-end pt-0">
										<v-btn
											class="ml-2 mr-2"
											v-if="
												!inEditMode &&
												canEdit(this.plannedCourse.office_id) &&
												plannedCourse.can_delete
											"
											color="warning"
											@click="deleteClick(plannedCourse.id)"
											:loading="deleting"
										>
											<v-icon small>fas fa-trash</v-icon>&nbsp;{{ $t('buttons.delete') }}
										</v-btn>
										<v-btn
											v-if="inEditMode && canEdit(plannedCourse.office_id)"
											class="ml-2 mr-2"
											color="primary"
											@click="saveClick()"
										>
											<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
										</v-btn>
										<v-btn
											v-if="
												!inEditMode &&
												plannedCourse.planned_course_status_id != 4 &&
												plannedCourse.planned_course_status_id != 5 &&
												canEdit(plannedCourse.office_id)
											"
											class="ml-2 mr-2"
											color="primary"
											@click="editClick()"
										>
											<v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
										</v-btn>

										<v-btn class="mr-2" color="basicButton" @click="backClick">
											<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
										</v-btn>
									</v-flex>
								</v-row>
								<v-row wrap>
									<v-col cols="12" class="pt-0">
										<v-col cols="12">
											<Dropdown
												:disabled="$route.params.id != 0"
												v-model="plannedCourse.department_id"
												:ajax="true"
												:clearable="true"
												:data="'departments'"
												:errorBorder="!plannedCourseValidation.department_id"
												:label="'* ' + $t('fields.department')"
											></Dropdown>
										</v-col>
										<v-col cols="12" v-if="departmentExists">
											<Dropdown
												:readonly="!inEditMode"
												:disabled="$route.params.id != 0"
												v-model="plannedCourse.course_id"
												:ajax="departmentExists"
												:clearable="true"
												:data="'courses/' + plannedCourse.department_id"
												:errorBorder="!plannedCourseValidation.course_id"
												:label="$t('fields.course')"
											></Dropdown>
										</v-col>
									</v-col>
								</v-row>
								<v-row v-if="plannedCourse.course_id != null">
									<Recommendations
										:courseId="plannedCourse.course_id"
										@duration="duration"
									></Recommendations>
								</v-row>
								<v-divider class="pa-2"></v-divider>
								<v-row wrap class="pl-2 pr-2">
									<v-flex lg6 xs12 sm12 class="pt-0">
										<div :class="['text-h6', 'pa-2']">{{ $t('titles.coursePlanning') }}</div>
										<v-col cols="12" v-if="$route.params.id != 0">
											<InputField
												:disabled="true"
												v-model="plannedCourse.id"
												:label="$t('fields.id')"
											></InputField>
										</v-col>
										<v-col
											cols="12"
											class="pt-1"
											v-if="
												$route.params.id == 0 &&
												plannedCourse.planned_course_status_id != 3 &&
												plannedCourse.planned_course_status_id != 4 &&
												plannedCourse.planned_course_status_id != 5
											"
										>
											<Dropdown
												:readonly="!inEditMode"
												v-model="plannedCourse.planned_course_status_id"
												:ajax="true"
												:data="'planned-course-statuses'"
												:errorBorder="!plannedCourseValidation.planned_course_status_id"
												:label="'* ' + $t('fields.status')"
											></Dropdown>
										</v-col>
										<v-col cols="12" v-if="inEditMode && $myStore.state.user.user_role_id == 2">
											<Dropdown
												:readonly="!inEditMode"
												:disabled="
													plannedCourse.planned_course_status_id != 1 &&
													plannedCourse.planned_course_status_id != 2 &&
													plannedCourse.planned_course_status_id != 6
												"
												v-model="plannedCourse.office_id"
												:ajax="true"
												:data="'planned-course-offices?ids=' + $myStore.state.user.offices"
												:errorBorder="!plannedCourseValidation.office_id"
												:label="'* ' + $t('fields.office')"
											></Dropdown>
										</v-col>
										<v-col cols="12" v-else>
											<Dropdown
												:readonly="!inEditMode"
												:disabled="
													plannedCourse.planned_course_status_id != 1 &&
													plannedCourse.planned_course_status_id != 2 &&
													plannedCourse.planned_course_status_id != 6
												"
												v-model="plannedCourse.office_id"
												:ajax="true"
												:data="'offices'"
												:errorBorder="!plannedCourseValidation.office_id"
												:label="'* ' + $t('fields.office')"
											></Dropdown>
										</v-col>
										<v-col cols="12">
											<DatePicker
												:readonly="!inEditMode"
												:disabled="
													plannedCourse.planned_course_status_id != 1 &&
													plannedCourse.planned_course_status_id != 2 &&
													plannedCourse.planned_course_status_id != 3 &&
													plannedCourse.planned_course_status_id != 6
												"
												v-model="plannedCourse.start_date"
												:errorBorder="!plannedCourseValidation.start_date"
												:date-label="'* ' + $t('fields.startDate')"
											></DatePicker>
										</v-col>
										<v-col cols="12">
											<DatePicker
												:readonly="!inEditMode"
												:disabled="
													plannedCourse.planned_course_status_id != 1 &&
													plannedCourse.planned_course_status_id != 2 &&
													plannedCourse.planned_course_status_id != 3 &&
													plannedCourse.planned_course_status_id != 6
												"
												v-model="plannedCourse.end_date"
												:errorBorder="!plannedCourseValidation.end_date"
												:date-label="'* ' + $t('fields.endDate')"
											></DatePicker>
										</v-col>
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												:disabled="
													plannedCourse.planned_course_status_id == 4 ||
													plannedCourse.planned_course_status_id == 5
												"
												v-model="plannedCourse.min_students"
												:errorBorder="!plannedCourseValidation.min_students"
												:label="'* ' + $t('fields.minStudents')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												:disabled="
													plannedCourse.planned_course_status_id == 4 ||
													plannedCourse.planned_course_status_id == 5
												"
												v-model="plannedCourse.max_students"
												:errorBorder="!plannedCourseValidation.max_students"
												:label="'* ' + $t('fields.maxStudents')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<Dropdown
												:readonly="!inEditMode"
												:disabled="
													plannedCourse.planned_course_status_id == 4 ||
													plannedCourse.planned_course_status_id == 5
												"
												v-model="plannedCourse.language_id"
												:data="'languages'"
												:ajax="true"
												:errorBorder="!plannedCourseValidation.language_id"
												:label="'* ' + $t('fields.language')"
											></Dropdown>
										</v-col>
										<v-col cols="12">
											<Dropdown
												:readonly="!inEditMode"
												:disabled="
													plannedCourse.planned_course_status_id == 4 ||
													plannedCourse.planned_course_status_id == 5
												"
												v-model="plannedCourse.partner_id"
												:data="'partners'"
												:ajax="true"
												:clearable="true"
												:label="$t('fields.partner')"
											></Dropdown>
										</v-col>
										<v-col cols="12">
											<TextArea
												:readonly="!inEditMode"
												:disabled="
													plannedCourse.planned_course_status_id == 4 ||
													plannedCourse.planned_course_status_id == 5
												"
												v-model="plannedCourse.note"
												:errorBorder="!plannedCourseValidation.note"
												:label="$t('fields.note')"
												rows="3"
											></TextArea>
										</v-col>
									</v-flex>
									<v-flex lg6 xs12 sm12 class="pt-0" v-if="$route.params.id != 0">
										<v-row class="d-flex justify-space-between">
											<v-col>
												<div :class="['text-h6', 'pl-2']">
													{{ $t('titles.courseManagment') }}
												</div>
											</v-col>
											<v-col
												class="d-flex justify-end pb-0 pt-0"
												v-if="!inEditMode && canEdit(plannedCourse.office_id)"
											>
												<v-btn
													v-if="plannedCourse.planned_course_status_id == 3"
													class="ml-2 mr-2"
													color="primary"
													@click="concludeCourseClick"
												>
													<v-icon small>fa-lock</v-icon>&nbsp;{{
														$t('buttons.concludeCourse')
													}}
												</v-btn>
												<v-btn
													v-if="
														plannedCourse.planned_course_status_id != 4 &&
														plannedCourse.planned_course_status_id != 5 &&
														canEdit(plannedCourse.office_id)
													"
													class="ml-2 mr-2"
													color="basicButton"
													@click="cancelCourseClick"
												>
													<v-icon small>fa-cancel</v-icon>&nbsp;{{
														$t('buttons.cancelCourse')
													}}
												</v-btn>
												<v-btn
													class="ml-2 mr-2"
													color="basicButton"
													@click="exportEnrolledCandidatesRegistar"
												>
													<v-icon small>file-excel</v-icon>&nbsp;{{
														$t('buttons.enrolledCandidatesRegister')
													}}
												</v-btn>
											</v-col>
										</v-row>
										<v-col
											cols="12"
											class="pt-1"
											v-if="
												plannedCourse.planned_course_status_id != 3 &&
												plannedCourse.planned_course_status_id != 4 &&
												plannedCourse.planned_course_status_id != 5
											"
										>
											<Dropdown
												:readonly="!inEditMode"
												v-model="plannedCourse.planned_course_status_id"
												:ajax="true"
												:data="'planned-course-statuses'"
												:errorBorder="!plannedCourseValidation.planned_course_status_id"
												:label="'* ' + $t('fields.status')"
											></Dropdown>
										</v-col>
										<v-col
											cols="12"
											class="pt-1"
											v-if="
												plannedCourse.planned_course_status_id == 3 ||
												plannedCourse.planned_course_status_id == 4 ||
												plannedCourse.planned_course_status_id == 5
											"
										>
											<InputField
												:disabled="true"
												v-model="plannedCourse.planned_course_status_name"
												:label="$t('fields.status')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:disabled="true"
												v-model="plannedCourse.code"
												:errorBorder="!plannedCourseValidation.code"
												:label="$t('fields.courseNumber')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<DatePicker
												:readonly="!inEditMode"
												:disabled="
													plannedCourse.planned_course_status_id == 4 ||
													plannedCourse.planned_course_status_id == 5
												"
												v-model="plannedCourse.exam_date"
												:errorBorder="!plannedCourseValidation.exam_date"
												:date-label="$t('fields.examDate')"
											></DatePicker>
										</v-col>
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												:disabled="true"
												v-model="plannedCourse.preregistration"
												:errorBorder="!plannedCourseValidation.preregistration"
												:label="'* ' + $t('fields.preregistration')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												:disabled="true"
												v-model="plannedCourse.registration"
												:errorBorder="!plannedCourseValidation.registration"
												:label="'* ' + $t('fields.registration')"
											></NumberField>
										</v-col>
										<v-col
											cols="12"
											v-if="
												(plannedCourse.students_file.upload_id != null && !inEditMode) ||
												inEditMode
											"
										>
											<Upload
												:readonly="!inEditMode"
												:label="$t('fields.studentSignatureList')"
												v-model="plannedCourse.students_file"
												:errorBorder="!plannedCourseValidation.students_file"
											></Upload>
										</v-col>
										<v-col
											cols="12"
											v-if="
												(plannedCourse.teachers_file.upload_id != null && !inEditMode) ||
												inEditMode
											"
										>
											<Upload
												:readonly="!inEditMode"
												:label="$t('fields.teacherSignatureList')"
												v-model="plannedCourse.teachers_file"
												:errorBorder="!plannedCourseValidation.teachers_file"
											></Upload>
										</v-col>
										<v-col cols="12" class="d-flex justify-center" v-if="!inEditMode">
											<v-btn
												v-if="
													(plannedCourse.planned_course_status_id == 1 ||
														plannedCourse.planned_course_status_id == 2) &&
													canEdit(plannedCourse.office_id)
												"
												class="ml-2 mr-2 pa-8"
												color="primary"
												@click="startCourseClick"
											>
												<v-icon small>fa-play</v-icon>&nbsp;{{ $t('buttons.startCourse') }}
											</v-btn>
										</v-col>
									</v-flex>
								</v-row>
							</v-card-text>
						</v-card>
					</v-tab-item>
					<v-tab-item v-if="$route.params.id != 0 && !inEditMode">
						<Candidates
							:plannedCourseId="plannedCourse.id"
							:canEdit="canEdit(plannedCourse.office_id)"
						></Candidates>
					</v-tab-item>
					<v-tab-item
						v-if="
							$route.params.id != 0 &&
							plannedCourse.planned_course_status_id != 4 &&
							plannedCourse.planned_course_status_id != 5 &&
							!inEditMode
						"
					>
						<Appointments
							:plannedCourseId="plannedCourse.id"
							:courseId="plannedCourse.course_id"
							:locationId="plannedCourse.office_id"
							:courseStatus="plannedCourse.planned_course_status_id"
							:canEdit="canEdit(plannedCourse.office_id)"
						></Appointments
					></v-tab-item>
					<v-tab-item
						v-if="
							$route.params.id != 0 &&
							plannedCourse.planned_course_status_id != 4 &&
							plannedCourse.planned_course_status_id != 5 &&
							!inEditMode
						"
						><Schedule :courseId="plannedCourse.course_id"></Schedule>
					</v-tab-item>
					<v-tab-item v-if="!inEditMode">
						<Teachers
							:plannedCourseId="plannedCourse.id"
							:canEdit="canEdit(plannedCourse.office_id)"
						></Teachers>
					</v-tab-item>
					<v-tab-item v-if="!inEditMode"
						><Costs :plannedCourseId="plannedCourse.id" :canEdit="canEdit(plannedCourse.office_id)"></Costs
					></v-tab-item>
					<v-tab-item v-if="!inEditMode"
						><Surveys :registration="plannedCourse.registration"></Surveys
					></v-tab-item>
				</v-tabs>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import InputField from '../../trinkets/InputField';
import PlannedCourse from '../../../models/PlannedCourse';
import NumberField from '../../trinkets/NumberField';
import Dropdown from '../../trinkets/Dropdown';
import DatePicker from '../../trinkets/DatePicker';
import TextArea from '../../trinkets/TextArea';
import Upload from '../../trinkets/Upload';
import Recommendations from './Recommendations';
import Surveys from './Surveys';
import Candidates from './Candidates';
import Costs from './Costs';
import Appointments from './Appointments';
import Schedule from './Schedule';
import Teachers from './Teachers';

export default {
	name: 'PlannedCourse',
	components: {
		InputField,
		Upload,
		NumberField,
		DatePicker,
		Dropdown,
		TextArea,
		Recommendations,
		Candidates,
		Costs,
		Appointments,
		Schedule,
		Teachers,
		Surveys,
	},
	props: {
		plannedCourseId: [String, Number],
	},
	data: function () {
		return {
			plannedCourse: new PlannedCourse({ id: this.$route.params.id }),
			plannedCourseValidation: new PlannedCourse({}, true),
			initialLoad: false,
			inEditMode: false,
			lockKey: 'planned-course',
			lockTimer: null,
			moduleName: '',
			moduleItem: {},
			departmentExists: false,
			courseDuration: null,
			deleting: false,
		};
	},
	watch: {
		'plannedCourse.department_id': function (newVal) {
			if (newVal !== null) {
				this.departmentExists = true;
			} else {
				this.departmentExists = false;
			}
		},
		'plannedCourse.start_date': function (newVal) {
			if (newVal) {
				if (this.courseDuration != null) {
					let startDate = new Date(this.plannedCourse.start_date);
					let duration = this.courseDuration != 0 ? this.courseDuration - 1 : this.courseDuration;
					let endDateTimestamp = startDate.setDate(startDate.getDate() + duration);
					let endDate = new Date(endDateTimestamp);
					this.plannedCourse.end_date = endDate.toISOString().slice(0, 10);
				}
			}
		},
	},
	methods: {
		editClick() {
			let vm = this;
			this.$setLock(this, this.lockKey + '|' + this.plannedCourse.id, (data) => {
				if (data.success) {
					vm.inEditMode = true;
					vm.lockTimer = setInterval(() => {
						vm.$setLock(vm, vm.lockKey + '|' + vm.plannedCourse.id);
					}, 10000);
				} else {
					vm.$alert(
						vm
							.$t('alerts.recordLocked')
							.split('%name%')
							.join(data.locked_by.first_name + ' ' + data.locked_by.last_name)
					);
				}
			});
		},
		backClick() {
			this.$router.go(-1);
		},
		deleteClick(plannedCourseId) {
			let vm = this;
			this.$verify(this.$t('alerts.deletionQuestion'), (result) => {
				if (result) {
					vm.deleting = true;
					vm.$APICall(
						'delete',
						'planned-courses/' + plannedCourseId,
						{ planned_course_id: plannedCourseId },
						(data, success) => {
							if (success) {
								vm.$notify(vm.$t('alerts.basicDelete'));
								vm.backClick();
							} else {
								if (Object.hasOwn(data, 'custom')) {
									vm.$alert(data.message);
									vm.backClick();
								} else {
									vm.$alert(vm.$t('alerts.basicError'));
								}
							}
							vm.deleting = false;
						},
						false
					);
				}
			});
		},
		duration(duration) {
			this.courseDuration = duration;
		},
		saveClick() {
			let success = true;
			let errorMessages = '';

			if (!this.plannedCourse.department_id) {
				success = false;
				this.plannedCourseValidation.department_id = false;
			} else {
				this.plannedCourseValidation.department_id = true;
			}

			if (!this.plannedCourse.course_id) {
				success = false;
				this.plannedCourseValidation.course_id = false;
			} else {
				this.plannedCourseValidation.course_id = true;
			}

			if (!this.plannedCourse.office_id) {
				success = false;
				this.plannedCourseValidation.office_id = false;
			} else {
				this.plannedCourseValidation.office_id = true;
			}

			if (!this.plannedCourse.start_date) {
				success = false;
				this.plannedCourseValidation.start_date = false;
			} else {
				this.plannedCourseValidation.start_date = true;
			}

			if (!this.plannedCourse.end_date) {
				success = false;
				this.plannedCourseValidation.end_date = false;
			} else {
				this.plannedCourseValidation.end_date = true;
			}

			if (this.plannedCourse.end_date < this.plannedCourse.start_date) {
				success = false;
				this.plannedCourseValidation.end_date = false;
				errorMessages += this.$t('alerts.plannedCourseEndDateError') + '<br />';
			} else {
				this.plannedCourseValidation.end_date = true;
			}

			if (this.plannedCourse.min_students == null) {
				success = false;
				this.plannedCourseValidation.min_students = false;
			} else {
				if (this.plannedCourse.min_students < 0 || this.plannedCourse.min_students > 1000) {
					this.plannedCourseValidation.min_students = false;
					errorMessages +=
						this.$t('alerts.valueError')
							.replace('%field%', this.$t('fields.minStudents'))
							.replace('%min%', '1')
							.replace(
								'%max%',
								this.plannedCourse.max_students <= 1000 ? this.plannedCourse.max_students : '1000'
							) + '<br />';
				} else {
					this.plannedCourseValidation.min_students = true;
				}
			}

			if (this.plannedCourse.max_students == null) {
				success = false;
				this.plannedCourseValidation.max_students = false;
			} else {
				if (
					(this.plannedCourse.max_students < 0 || this.plannedCourse.max_students > 1000) &&
					this.plannedCourse.max_students >= this.plannedCourse.min_students
				) {
					this.plannedCourseValidation.max_students = false;
					errorMessages +=
						this.$t('alerts.valueError')
							.replace('%field%', this.$t('fields.minStudents'))
							.replace('%min%', this.plannedCourse.min_students ? this.plannedCourse.min_students : '0')
							.replace('%max%', '1000') + '<br />';
				} else {
					this.plannedCourseValidation.max_students = true;
				}
			}

			if (!this.plannedCourse.planned_course_status_id) {
				success = false;
				this.plannedCourseValidation.planned_course_status_id = false;
			} else {
				this.plannedCourseValidation.planned_course_status_id = true;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				this.saveData();
			}
		},
		startCourseClick() {
			this.$verify(this.$t('alerts.startCourseQuestion'), (result) => {
				if (result) {
					this.plannedCourse.planned_course_status_id = 3;
					this.saveData();
				}
			});
		},
		cancelCourseClick() {
			this.$verify(this.$t('alerts.cancelCourseQuestion'), (result) => {
				if (result) {
					this.plannedCourse.planned_course_status_id = 4;
					this.saveData();
				}
			});
		},
		concludeCourseClick() {
			this.$verify(this.$t('alerts.concludeCourseQuestion'), (result) => {
				if (result) {
					this.plannedCourse.planned_course_status_id = 5;
					this.saveData();
				}
			});
		},
		exportEnrolledCandidatesRegistar() {
			let vm = this;
			this.$APICall(
				'get',
				'planned-courses/enrolled-candidates-registar/' + this.$route.params.id,
				null,
				(data, success) => {
					if (success) {
						window.open(data.link);
					} else {
						if (Object.hasOwn(data, 'custom')) {
							vm.$alert(data.message);
							vm.inEditMode = false;
							vm.backClick();
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					}
				},
				false
			);
		},
		canEdit(office_id) {
			if (this.$myStore.state.user.user_role_id == 1) {
				return true;
			} else {
				return this.$myStore.state.user.offices.includes(office_id);
			}
		},
		saveData() {
			let vm = this;
			let action = 'post';
			let addition = '';
			if (vm.plannedCourse.id != 0) {
				action = 'put';
				addition = '/' + vm.plannedCourse.id;
			}
			this.$APICall(action, 'planned-courses' + addition, this.plannedCourse, (data, success) => {
				if (success) {
					vm.inEditMode = false;
					if (vm.plannedCourse.id == 0) {
						vm.$notify(vm.$t('alerts.basicAdd'));
					} else {
						vm.$notify(vm.$t('alerts.basicUpdate'));
					}
					vm.backClick();
				} else {
					if (Object.hasOwn(data, 'custom')) {
						vm.$alert(data.message);
						vm.inEditMode = false;
						vm.backClick();
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				}
			});
		},
		setBreadcrumbs(addingItem = true) {
			if (addingItem) {
				this.$myStore.commit('setBreadcrumbs', [
					{
						text: this.$t('modules.plannedCourses'),
						href: '/#/planned-courses',
						disabled: false,
					},
					{
						text: this.$t('modules.newPlannedCourse'),
						href: '/#/planned-courses/0',
						disabled: true,
					},
				]);
			} else {
				this.$myStore.commit('setBreadcrumbs', [
					{
						text: this.$t('modules.plannedCourses'),
						href: '/#/planned-courses',
						disabled: false,
					},
					{
						text: this.plannedCourse.course_name + ' (' + this.plannedCourse.id + ')',
						href: '/#/planned-courses/' + this.plannedCourse.id,
						disabled: true,
					},
				]);
			}
		},
		fetchData(refreshing = false) {
			let vm = this;

			this.$APICall('get', 'planned-courses/' + this.$route.params.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.plannedCourse = usableData;
					if (!refreshing) {
						vm.setBreadcrumbs(false);
					}
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
				}
			});
		},
	},

	beforeRouteLeave(to, from, next) {
		let vm = this;
		if (this.inEditMode) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				if (result) {
					if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
					vm.$removeLock(vm, vm.lockKey + '|' + vm.plannedCourse.id);
					next(true);
				} else {
					next(false);
				}
			});
		} else {
			if (this.lockTimer !== null) clearInterval(this.lockTimer);
			vm.$removeLock(vm, vm.lockKey + '|' + vm.plannedCourse.id);
			next(true);
		}
	},

	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		let vm = this;
		this.$modalBus.$on('reloadPlannedCourse', () => {
			vm.fetchData(true);
		});
		if (this.plannedCourse.id != 0) {
			this.fetchData();
		} else {
			this.setBreadcrumbs();
			this.inEditMode = true;
			this.initialLoad = true;
		}
	},
};
</script>

<style scoped></style>
